import React from "react";
import styles from '../HelpPage.module.css';

import { FaEnvelope, FaPhoneAlt } from 'react-icons/fa';

const ContactUs = () => {
    return(
        <section className={styles.helpSection}>
        <p>
            If you need further assistance, encountered an issue, or have any questions, please feel free to reach out to us:
        </p>
        {/* The structure here is fine, styles will change its appearance */}
        <div className={styles.contactCard}>
            <div className={styles.contactItem}>
                <FaEnvelope className={styles.contactIcon} />
                <div> {/* Optional: Wrap text for better potential wrapping */}
                    <span className={styles.contactLabel}>Email:</span>
                    <a href="mailto:info@ecombuddha.in" className={styles.contactValue}>
                        info@ecombuddha.in
                    </a>
                </div>
            </div>
            <div className={styles.contactItem}>
                <FaPhoneAlt className={styles.contactIcon} />
                 <div> {/* Optional: Wrap text */}
                    <span className={styles.contactLabel}>Phone:</span>
                    <p className={styles.contactNumber} style={{color:'#0B6FE9', fontWeight:'500'}}>
                        +91 8108264474
                    </p>
                </div>
            </div>
        </div>
    </section>
    );
};

export default ContactUs;